import React, { useState } from "react";
import PropTypes from "prop-types";
import { Slide, ToastContainer } from "react-toastify";
import MediaGrid from "./MediaGrid";

const App = ({ mediaPageInfoJson, mediaItemsJson }) => {
	const { title, subtitle, description, pdfDownload } =
		JSON.parse(mediaPageInfoJson);
	const [mediaItems] = useState(JSON.parse(mediaItemsJson));

	return (
		<>
			<MediaGrid
				pageTitle={title}
				pageSubtitle={subtitle}
				pageDescription={description}
				pdfDownload={pdfDownload}
				mediaItems={mediaItems}
			/>
			<ToastContainer position="bottom-right" transition={Slide} transitionDuration={1000} hideProgressBar={true}/>
		</>
	);
};

App.propTypes = {
	mediaItemsJson: PropTypes.string,
	mediaPageInfoJson: PropTypes.string,
};

export default App;
